import axios from "axios";
import { get, post } from './base';
import { makeQuery } from "@/api/base";

class afficheAPI {

    /**
     * 查询置顶公告分页
     * @param {*} searchForm 
     */
    static getAffiches(searchForm) {
    return post('/affiche/list',searchForm);
    }

    /**
     * 删除置顶公告
     * @param {*} id 
     */
    static delAffiche(id) {
    return axios.get(makeQuery("/affiche/del", { id }));
    }

    /**
     * 创建或编辑置顶公告
     * @param {*} data 
     */
    static addAffiche(data) {
    return axios.post("/affiche/add", data);
    }

    /**
     * 改变是否启用
     * @param {*} para 
     */
    static changeIsOpen(para) {
    return axios.post("/affiche/state", para);
    }

    /**
     * 得到启用的公告
     */
    static getOpenAffiche(userId) {
    return axios.get(makeQuery("/affiche/open", { userId }));
    }

    /**
     * 创建或编辑用户置顶公告
     * @param {*} data 
     */
    static addStickyAfficheUser(data) {
    return axios.post("/affiche/user/add", data);
    }

    /**
     * 是否存在已启用的公告
     */
    static isHaveOpenAffiche() {
    return axios.get("/affiche/open/exist");
    }

}

export default afficheAPI;